/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ThemeSetting
 */
export interface ThemeSetting {
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    backgroundTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    primaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    primaryTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    secondaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    secondaryTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    errorColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    errorTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    warningColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    warningTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    iconPack?: string;
    /**
     * 
     * @type {number}
     * @memberof ThemeSetting
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ThemeSetting
     */
    courierId?: number;
    /**
     * 
     * @type {string}
     * @memberof ThemeSetting
     */
    landingPageVersion?: string;
}

/**
 * Check if a given object implements the ThemeSetting interface.
 */
export function instanceOfThemeSetting(value: object): value is ThemeSetting {
    return true;
}

export function ThemeSettingFromJSON(json: any): ThemeSetting {
    return ThemeSettingFromJSONTyped(json, false);
}

export function ThemeSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThemeSetting {
    if (json == null) {
        return json;
    }
    return {
        
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'backgroundTextColor': json['backgroundTextColor'] == null ? undefined : json['backgroundTextColor'],
        'primaryColor': json['primaryColor'] == null ? undefined : json['primaryColor'],
        'primaryTextColor': json['primaryTextColor'] == null ? undefined : json['primaryTextColor'],
        'secondaryColor': json['secondaryColor'] == null ? undefined : json['secondaryColor'],
        'secondaryTextColor': json['secondaryTextColor'] == null ? undefined : json['secondaryTextColor'],
        'errorColor': json['errorColor'] == null ? undefined : json['errorColor'],
        'errorTextColor': json['errorTextColor'] == null ? undefined : json['errorTextColor'],
        'warningColor': json['warningColor'] == null ? undefined : json['warningColor'],
        'warningTextColor': json['warningTextColor'] == null ? undefined : json['warningTextColor'],
        'iconPack': json['iconPack'] == null ? undefined : json['iconPack'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'landingPageVersion': json['landingPageVersion'] == null ? undefined : json['landingPageVersion'],
    };
}

export function ThemeSettingToJSON(json: any): ThemeSetting {
    return ThemeSettingToJSONTyped(json, false);
}

export function ThemeSettingToJSONTyped(value?: ThemeSetting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'backgroundColor': value['backgroundColor'],
        'backgroundTextColor': value['backgroundTextColor'],
        'primaryColor': value['primaryColor'],
        'primaryTextColor': value['primaryTextColor'],
        'secondaryColor': value['secondaryColor'],
        'secondaryTextColor': value['secondaryTextColor'],
        'errorColor': value['errorColor'],
        'errorTextColor': value['errorTextColor'],
        'warningColor': value['warningColor'],
        'warningTextColor': value['warningTextColor'],
        'iconPack': value['iconPack'],
        'id': value['id'],
        'courierId': value['courierId'],
        'landingPageVersion': value['landingPageVersion'],
    };
}

